export const CATEGORY_MANAGER = 1
export const CATEGORY_ALLOCATOR = 2
export const CATEGORY_SERVICE_PROVIDER = 3
export const CATEGORY_CONTEXT = 4
export const CATEGORY_MEDIA = 5
export const CATEGORY_CFN = 6
